import { getIsQuestWorkflow, getIsSeason3, getIsSideQuest, getIsDeepLink } from '../selectors';
import { SEASON } from '../data/constants';

import * as workshopActions from './workshopActions';
import * as questsActions from './questsActions';

export const setQuestStepLevelFailed = (game, level) => (dispatch, getState) => {
  const state = getState();

  const isQuestWorkflow = getIsQuestWorkflow(state);
  const { questWorkflowReducer: { season } } = state;

  if (level < 0 || !isQuestWorkflow) {
    return;
  }

  if (season === SEASON.GRADE_4_5) {
    dispatch(workshopActions.notifyGameLevelFailed(game, level));
  } else {
    dispatch(questsActions.notifyGameLevelFailed(game, level));
  }
};

export const setQuestStepLevelMastered = (game, levelMastered) => (dispatch, getState) => {
  const state = getState();

  const isQuestWorkflow = getIsQuestWorkflow(state);
  const { questWorkflowReducer: { season } } = state;

  if (levelMastered < 0 || !isQuestWorkflow) {
    return;
  }

  if (season === SEASON.GRADE_4_5) {
    dispatch(workshopActions.notifyGameLevelSuccess(game, levelMastered));
  } else {
    dispatch(questsActions.notifyGameLevelSuccess(game, levelMastered));
  }
};

export const setQuestBookMastered = (gameId) => (dispatch, getState) => {
  const state = getState();

  const isQuestWorkflow = getIsQuestWorkflow(state);
  const isWorkshop = getIsSeason3(state);
  const isSideQuest = getIsSideQuest(state);
  const isDeepLink = getIsDeepLink(state);

  if (isDeepLink || !isQuestWorkflow || isSideQuest) {
    return;
  }

  if (isWorkshop) {
    dispatch(workshopActions.notifyBookSuccess());
  } else {
    dispatch(questsActions.notifyBookSuccess(gameId));
  }
};
